export default "__VITE_ASSET__B_ZRH17v__"